// extracted by mini-css-extract-plugin
export default {"action-button":"delete-project_action-button__ostdC"};